import React from 'react'

function Dummy() {
  return (
    <>
    <div className='' style={{marginTop:"115px"}}>dummy</div>
    <div className="row">
        <div className="col-lg-6" style={{backgroundColor:"green", color:"white", display:"block-inline"}}>
            <h2>Left Column</h2>
            <p>This is the left column</p>

        </div>
        <div className="col-lg-6" style={{backgroundColor:"black", color:"white"}}>dfvsedvfs</div>
    </div>
    </>

  )
}

export default Dummy